import React from "react";
import { DiscoverConstants } from "../../../configurations/discoverConfigs/discoverConstants";
import { Spinner } from "../../common/spinner";

const statusClass = status => {
  let statusStyle = "";
  switch (status) {
    case DiscoverConstants.CaseRequestStatus.Successful:
      statusStyle = "success";
      break;
    case DiscoverConstants.CaseRequestStatus.Declined:
      statusStyle = "warning";
      break;
    case DiscoverConstants.CaseRequestStatus.Failed:
      statusStyle = "danger";
      break;
    default:
      statusStyle = "info";
  }
  return statusStyle;
};

const CaseRequestDetails = ({
  caseRequest,
  transactionDetails,
  startCaseCreation,
  fetchingTransacation,
  fetchingCase,
  cancelling,
  cancelCaseRequest
}) => (
  <div>
    <div className="row">
      <div className="col-xs-12">
        <h4 className="bold">
          {caseRequest.requestType}
          <br />
          <small>
            <strong>Created by:</strong> {caseRequest.createdBy} on{" "}
            {caseRequest.createdOn} <br /> <strong>Last updated by:</strong>{" "}
            {caseRequest.lastUpdatedBy} on {caseRequest.lastUpdatedOn}
          </small>
        </h4>
        <hr />
        <div className={`alert alert-${statusClass(caseRequest.status)}`}>
          <p>
            <strong>Status: </strong> {caseRequest.status}
          </p>
          <p>
            <strong>Message:</strong> {caseRequest.responseMessage}
          </p>
          <p>
            <strong>Last attempted on:</strong> {caseRequest.lastAttemptOn}
          </p>
        </div>
      </div>
    </div>
    <div className="row">
      {caseRequest.transactionReference && (
        <div className="col-sm-5">
          <div>
            <strong>Transaction Reference: </strong>{" "}
            <span>{caseRequest.transactionReference} </span>
          </div>
        </div>
      )}
      {caseRequest.messageId && (
        <div className="col-sm-4">
          <div>
            <strong>Message ID: </strong> <span>{caseRequest.messageId}</span>
          </div>
        </div>
      )}
      {caseRequest.domain && (
        <div className="col-sm-3">
          <div>
            <strong>Issuer: </strong> <span>{caseRequest.domain}</span>
          </div>
        </div>
      )}
    </div>
    <hr />

    {transactionDetails && transactionDetails.dnCaseNumber && (
      <div className="alert alert-info text-center">
        A case has already been created for this transaction.{" "}
        <strong>Case number: {transactionDetails.dnCaseNumber}</strong>
      </div>
    )}

    <div className="row">
      <div className="col-xs-12 text-center">
        {caseRequest.status === DiscoverConstants.CaseRequestStatus.Declined ? (
          <div>
            <button
              disabled={
                fetchingTransacation ||
                fetchingCase ||
                (transactionDetails && transactionDetails.dnCaseNumber)
              }
              className="btn btn-primary"
              onClick={startCaseCreation}
            >
              {fetchingTransacation ? (
                <div>
                  <Spinner className="pull-left" /> Fetching transaction details
                </div>
              ) : fetchingCase ? (
                <div>
                  <Spinner className="pull-left" /> Fetching case details
                </div>
              ) : (
                "Resolve Case"
              )}
            </button>{" "}
            <button
              className="btn btn-danger"
              onClick={e => {
                if (window.confirm("Are you sure you want to cancel?\nYou will no longer be able to perform any action on this request.")) {
                  cancelCaseRequest(e);
                }
              }}
              disabled={cancelling}
            >
              {cancelling ? <Spinner /> : "Cancel Case Request"}
            </button>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  </div>
);

export default CaseRequestDetails;



// WEBPACK FOOTER //
// ./src/components/discover/caseRequests/CaseRequestDetails.js